import { useHasAccess } from '@components/HasAccess'
import ParticipationStatus from '@components/participationStatus/ParticipationStatus'
import { EventParticipation as ParticipationModel } from '@models/Event'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  selectEventParticipationById,
  updateEventParticipation,
} from '@store/membership/EventParticipationReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Form, message } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_SUCCESS } from '../../App'

type Props = SBModelComponent<ParticipationModel> & {
  onChange?: () => void
}

const StatusManager: FC<Props> = ({ id, model, onChange }) => {
  const { hasAccess } = useHasAccess()
  const dispatch = useAppDispatch()
  const item = model ? model : useAppSelector(selectEventParticipationById(id!))

  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()

  if (!item) {
    return <></>
  }

  const handleStatusChange = (values: number) => {
    setIsLoading(true)
    dispatch(updateEventParticipation({ ...item, status: values }))
      .then(() => {
        message.success(DEFAULT_SUCCESS)
        onChange?.()
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Form form={form} initialValues={item}>
      <Form.Item name="status" noStyle>
        <SBAsyncSelect
          style={{ minWidth: 100 }}
          size="middle"
          searchFieldName="name"
          entity={Entity.eventParticipationStatus}
          disabled={isLoading || !hasAccess(Permission.manageRolesAdmin)}
          inlineEdit={{
            renderSelection: () => <ParticipationStatus.Tag id={item.status} />,
          }}
          onChange={handleStatusChange}
        />
      </Form.Item>
    </Form>
  )
}

type StatusManagerType = { StatusManager: typeof StatusManager }

export { StatusManager, type StatusManagerType }
